import { H3 } from '@h3/types';
import * as Api from '../../api';

export default class MessageCenterState {
    private _messageCount?: number;

    private _loadMessageCountPromise?: Promise<boolean>;

    get messageCount() {
        return this._messageCount || 0;
    }

    updateMessageCount(count: number) {
        this._messageCount = count;
    }

    async loadMessageCount() {
        if (!this._loadMessageCountPromise) {
            this._loadMessageCountPromise = Api.MessageCenter.getMessageList({
                pageIndex: 0,
                pageSize: 1,
                status: H3.Message.MessageStatus.UnRead,
                categories: [
                    H3.Message.MessageMenuType.Reminder,
                    H3.Message.MessageMenuType.ApplicationMessage,
                    H3.Message.MessageMenuType.SystemMessage,
                    H3.Message.MessageMenuType.OperationMesssge,
                ],
            })
                .then((res) => {
                    if (!res.successful) {
                        return false;
                    }
                    this._messageCount = res.returnData.unReadCount;
                    return true;
                })
                .catch(() => {
                    return false;
                })
                .finally(() => {
                    this._loadMessageCountPromise = void 0;
                });
        }
        return this._loadMessageCountPromise;
    }
}
